import { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import axios, { AxiosError, AxiosResponse } from "axios";

const axiosBaseQuery: BaseQueryFn<
  { url: string; method: string; data?: any; params?: any },
  unknown,
  AxiosError
> = async ({ url, method, data, params }) => {
  try {
    let response: AxiosResponse;

    // Use axios method based on the HTTP request method
    switch (method) {
      case "GET":
        response = await axios.get(url, { params });
        break;
      case "POST":
        response = await axios.post(url, data, { params });
        break;
      case "PUT":
        response = await axios.put(url, data, { params });
        break;
      case "DELETE":
        response = await axios.delete(url, { data, params });
        break;
      case "PATCH":
        response = await axios.patch(url, data, { params });
        break;
      default:
        throw new Error(`Unsupported method: ${method}`);
    }

    return { data: response.data };
  } catch (error: any) {
    // Handle and return errors in a standardized way
    return { error: error.response ? error.response.data : error.message };
  }
};

export { axiosBaseQuery };
export default axiosBaseQuery;
